import React, { ReactNode } from 'react';
import styles from './PageEmpty.module.scss';

interface PageEmptyProps {
  children?: ReactNode;
}

export const PageEmpty: React.FC<PageEmptyProps> = ({ children }) => {
  return (
    <div className={styles.pageEmpty}>
      {children}
    </div>
  );
};
